<template>
  <header ref="headerRef">
    <div class="layout">
      <router-link :to="{name: 'Home'}" class="logo"><img src="@/assets/images/common/MIMIO_B.I.gif" alt=""/></router-link>
      <div class="h-cont">
        <div class="gnb pc">
          <!-- 사용자 메뉴 -->
          <ul>
            <li>
              <router-link :to="{name: 'ArtistList'}" :class="{ on: $route.path.startsWith('/artist') }">
                ART & ARTISTS
              </router-link>
            </li>
            <li>
              <router-link :to="{name: 'Article'}" :class="{ on: $route.path.startsWith('/article') }">
                ARTICLE
              </router-link>
            </li>
            <li>
              <a style="cursor: not-allowed"
                 @mouseover="setHoverText('COMING SOON')"
                 @mouseleave="setHoverText('ARTSHOP')"
                 :style="{ fontSize: hoverTextArtshop === 'COMING SOON' ? '15px' : '' }"
              >
                {{ hoverTextArtshop }}</a>
            </li>
          </ul>
        </div>

        <div class="util-box">
          <div class="util-link">
            <a v-if="!isMobile" :href="linkApplyCollab" target="_blank" class="link-apply-collab" rel="noopener noreferrer" >협업 신청</a>
            <a v-if="!isMobile" :href="router.resolve({ name: 'ServiceInfo' }).href" target="_blank"
               class="link-apply-service" :style="{ 'color': route.path.includes('/info/service') ? '#F7BE17' : '' }" rel="noopener noreferrer" >서비스 소개</a>

            <UtilLinks @close="() => {}" />

          </div>
        </div>
      </div>
      <DropdownMenu
          :is-mobile="isMobile"
          :link-apply-collab="linkApplyCollab"
      />
    </div>
  </header>
</template>

<script setup>
import {
  nextTick,
  onMounted,
  ref, onUnmounted,
} from "vue";
import {useRouter, useRoute} from "vue-router";
import DropdownMenu from "@/components/layout/header/DropdownMenu.vue";
import UtilLinks from "@/components/layout/header/UtilLinks.vue";

const linkApplyCollab = 'https://forms.gle/6XChEe7aP5C4J7NK6';
const hoverTextArtshop = ref('ARTSHOP');

const setHoverText = (text) => {
  hoverTextArtshop.value = text;

  nextTick(() => {
    // 강제로 리플로우 발생 -> 즉시 적용되도록 만듦
    document.documentElement.style.display = "none";
    document.documentElement.offsetHeight;
    document.documentElement.style.display = "";
  });
};

const router = useRouter();
const route = useRoute();

const isMobile = ref(false); // header css가 따로 있어서 useDeviceStore 사용하면 변경 많아짐.

// 모바일 확인 함수
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 1024;
};

// 컴포넌트 마운트 시 동작 설정
onMounted(() => {
  checkMobile();
  window.addEventListener("resize", checkMobile);
});

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile);
});
</script>

<style scoped>

header.hide {
  transform: translateY(-100%);
}

</style>
